/**
 * Do not edit directly
 * Generated on Tue, 07 Feb 2023 13:10:43 GMT
 */

export default "PHBhdGggZD0iTTAuNSAwLjVWNi41SDguNVY1LjVIMS41VjEuNUgxNC41VjUuNUgxMy41VjYuNUgxNS41VjAuNUgwLjVaTTE0LjUgMTQuNUgxLjVWMTAuNUg0LjVWOS41SDAuNVYxNS41SDE1LjVWMTIuNUgxNC41VjE0LjVaTTIuNTQ5OTkgMi40OUgzLjU0OTk5VjMuNDlIMi41NDk5OVYyLjQ5Wk0zLjU3MDAxIDExLjQ2SDIuNTcwMDFWMTIuNDZIMy41NzAwMVYxMS40NlpNMTAuNSAxMS42MlYzLjVIMTEuNVYxMS42MkwxNC41OSA4LjY0TDE1LjI4IDkuMzZMMTEgMTMuNDlMNi43MTk5NyA5LjM2TDcuNDA5OTcgOC42NEwxMC41IDExLjYyWiIgZmlsbD0iaW5oZXJpdCIvPg==";